module.exports = __webpack_public_path__ + "static/st2-5-f50a9aa27ccbc15974ca53093b6617fa.jpg";